<template>
    <v-flex>
        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>           
        <v-layout row class="content-header">
            <v-flex md12 class="content-title" v-if="mostrarTextoInicial">
                <h2>Simples Nacional</h2>
                <h4>Informe o credenciamento e alíquota do Simples Nacional. </h4>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-row>
                    <p>&nbsp;</p>
                </v-row>
                <v-row>
                    <p v-if="mostrarTextoInicial && this.ultimaEnviada !== null && Object.keys(this.ultimaEnviada).length !== 0">
                        <v-alert v-if="ultimaEnviada.status == 2" type="success">
                            enviado no dia {{ FormatarData(ultimaEnviada.dataInclusao) }} Protocolo : {{ ultimaEnviada.protocolo }} foi finalizado.
                        </v-alert>
                        <v-alert v-if="ultimaEnviada.status != 2" type="info">
                            enviado no dia {{ FormatarData(ultimaEnviada.dataInclusao) }} Protocolo : {{ ultimaEnviada.protocolo }} está em processo.
                        </v-alert>                                                
                    </p>
                </v-row>
                <v-row v-if="mostrarTextoInicial" style="height: 300px;text-align:justify;" class="overflow-y-auto">
                    <p>       
                        A Lei Complementar nº 147/14 possibilitou, a partir de janeiro/2015, às corretoras de seguros a adesão ao regime tributário "Simples Nacional". Com isso, as corretoras que aderirem ao SIMPLES passarão a estar isentas da retenção do Imposto de Renda, pela fonte pagadora. Por outro lado, a referida Lei <span class="text-black">manteve a incidência e a retenção do ISSQN</span> na mesma forma como definida na Legislação de cada Município.
                    </p>
                    <p>
                        Sendo assim, tendo em vista o esclarecimento de dúvidas referentes a este processo, informamos:
                    </p>
                    <p>
                        a) a solicitação de opção pelo simples Nacional somente poderá ser realizada no mês de <span class="text-black">janeiro de cada ano</span>, até o seu último dia útil. Uma vez deferida, esta adesão produz efeitos a partir do primeiro dia do ano calendário de opção. 
                    </p>
                    <p>
                        b) a adesão ao  simples Nacional <span class="text-black">deverá ser informada formalmente</span> à fonte pagadora (Seguradoras) e comprovada mediante envio  de documento emitido pela Receita Federal com o deferimento de inclusão no Simples Nacional, podendo ser encaminhada "tela da consulta optantes Simples Nacional" ou o "Termo de deferimento da Opção pelo Simples Nacional" (preferencialmente), emitida no site da Receita Federal.
                    </p>
                    <p>
                        c) <span class="text-black">nos municípios</span> em que as Seguradoras são <span class="text-black">enquadradas como substitutos tributários</span> ou responsáveis solidários  o ISSQN  continuara sendo retido quando dos pagamentos.
                    </p>
                    <p>
                        d) face ao item anterior, mensalmente a corretora deverá <span class="text-black">informar à fonte pagadora (Seguradoras) a faixa de retenção (alíquota)</span> a que ela está enquadrada naquele período. A faixa de retenção corresponderá àquela definida no enquadramento da média de seu faturamento, na tabela estabelecida pela Receita Federal. Importante salientar que a ausência desta informação impossibilita o pagamento das comissões, uma vez que a Seguradora não tem como definir a alíquota correta para a retenção. É importante destacar que as corretoras que optarem pelo Simples <span class="text-black">não poderão emitir notas fiscais fora da competência</span> ou com destaque de percentuais de retenção diferente do que foi utilizado no pagamento.
                    </p>
                    <p>
                        e) visando facilitar o procedimento disposto no item "d", <span class="text-black">será disponibilizado no PORTAL DO CORRETOR</span> um campo para que as corretoras informem a adesão pelo Simples Nacional, anexem o comprovante de  deferimento da Receita Federal (conforme descrito no item "b") e informem a alíquota do ISSQN, para as corretoras domiciliadas em municípios em que a Companhia seja responsável pela sua retenção.
                    </p>
                    <p>
                        f) adicionalmente, esclarecemos que as corretoras, após optarem pelo Simples Nacional <span class="text-black">poderão também  ser  optante pelo SIMEI</span> -Sistema de Recolhimento em Valores Fixos Mensais dos Tributos Abrangidos pelo Simples Nacional . Os optantes pelo SIMEI deverão informar de imediato a Companhia em razão que <span class="text-black">neste sistema não há  incidência de IRRF e ISSQN</span>.
                    </p>
                    <p>
                        1. por fim salientamos que, conforme Resolução CGSN  nº 51/2008 "<span class="text-black">na incidência de retenção na fonte  do ISS a alíquota deve ser informada no documento fiscal e conforme inciso V  - caso não seja informado  a alíquota  na nota fiscal deverá se aplicada a alíquota maior (5%)</span>"
                    </p>
                    <p>
                        2. ”<span class="text-black">Alertamos que as comissões, eventualmente creditadas entre o período de início da vigência da Lei Complementar nº 147/14, qual seja, 01/01/2015, e o envio do comprovante de deferimento de inclusão no Simples Nacional, emitido pela Receita Federal, à Previsul Seguradora, sofrerão retenção de IRPJ, cabendo às Corretoras buscar a respectiva compensação/restituição junto ao Fisco.</span>" 
                    </p>
                </v-row>
                <v-row v-if="mostrarTextoInicial">
                    <p>&nbsp;</p>
                    <p>
                        <br />
                        <strong>PREVISUL SEGURADORA</strong>
                            <br /><br />
                        <v-btn color="primary" @click="mostrarTextoInicial = false;credenciamento = true; ">
                            <v-icon dark right style="margin-right:10px;">mdi-checkbox-marked-circle</v-icon>
                            &nbsp;&nbsp;
                            Informar  <strong>Credenciamento</strong> Simples Nacional 
                            <!-- ou SIMEI -->
                        </v-btn>
                        &nbsp;&nbsp;
                        <v-btn color="error" @click="mostrarTextoInicial = false;descredenciamento = true; ">
                            <v-icon dark right style="margin-right:10px;">mdi-cancel</v-icon>
                            &nbsp;&nbsp;
                            Informar  <strong>Descredenciamento</strong> Simples Nacional 
                            <!-- ou SIMEI -->
                        </v-btn>         
                    </p>
                </v-row>
                <v-row>
                      <v-card class="mx-auto" max-width="500" v-if="credenciamento">
                          <v-card-text>
                            <div>
                                <h2>Simples Nacional - Credenciamento</h2>
                                <br />
                                <p>Mensalmente a corretora deverá informar à Companhia a alíquota do ISSQN a que ela está enquadrada no Simples Nacional.</p>
                                <div>
                                    <v-switch v-model="simplesNacional" label="Enquadramento do Simples Nacional"></v-switch>
                                    <div v-if="simplesNacional">
                                        <!-- <v-select :items="aliquotaSimplesNacional" v-model="aliquota" label="Alíquota do ISSQN :" outlined></v-select> -->
                                        <!-- <v-slider v-model="aliquota" :snap="true" :min="2" :max="5" :step="0.01" thumb-label></v-slider>
                                        <v-text-field v-model="aliquota" label="Alíquota do ISSQN (%)" :readonly="true"></v-text-field> -->

                                        <v-text-field v-model="aliquota" label="Alíquota do ISSQN (%)" v-formatMoney="formatField" :rules="aliquotaRules" return-masked-value></v-text-field>

                                        <v-file-input chips v-model="arquivoSimplesNacional" label="Upload de documento" accept="image/bmp, image/jpeg, image/png, application/pdf"></v-file-input>
                                        <span>('Termo de deferimento da Opção pelo Simples Nacional emitido pela Receita Federal' ou 'tela da consulta optantes Simples Nacional emitido pela Receita Federal’)</span>                                
                                    </div>
                                    <!-- <v-switch v-model="simei" label="Enquadramento do SIMEI"></v-switch>
                                    <div v-if="simei">
                                        <v-file-input chips v-model="arquivoSimei" label="Upload de documento" accept="image/bmp, image/jpeg, image/png, application/pdf"></v-file-input>
                                        <span>('Termo de deferimento da Opção pelo Simples Nacional emitido pela Receita Federal' ou 'tela da consulta optantes Simples Nacional emitido pela Receita Federal’)</span>
                                        <br /><br />                                
                                    </div>                             -->                                             
                                </div>
                            </div>                              
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="primary" :disabled="(!simplesNacional || arquivoSimplesNacional == null) && (!simei || arquivoSimei == null)"  @click="SubmeterDados()">
                                <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                                &nbsp;&nbsp;
                                Informar Credenciamento
                            </v-btn>                                
                          </v-card-actions>                          
                      </v-card>
                      <v-card class="mx-auto" max-width="500" v-if="descredenciamento">
                          <v-card-text>
                            <div>
                                <h2>Simples Nacional - Descredenciamento</h2>
                                <br />
                                <p>&nbsp;</p>                        
                                <div>
                                    <v-switch v-model="simplesNacional" label="Descredenciamento do Simples Nacional"></v-switch>
                                    <div v-if="simplesNacional">
                                        <v-file-input chips v-model="arquivoSimplesNacional" label="Upload de documento" accept="image/bmp, image/jpeg, image/png, application/pdf"></v-file-input>
                                        <span>('Termo de deferimento da Opção pelo Simples Nacional emitido pela Receita Federal' ou 'tela da consulta optantes Simples Nacional emitido pela Receita Federal’)</span>                                
                                    </div>                            
                                    <!-- <v-switch v-model="simei" label="Descredenciamento do SIMEI"></v-switch>
                                    <div v-if="simei">
                                        <v-file-input chips v-model="arquivoSimei" label="Upload de documento" accept="image/bmp, image/jpeg, image/png, application/pdf"></v-file-input>
                                        <span>('Termo de deferimento da Opção pelo Simples Nacional emitido pela Receita Federal' ou 'tela da consulta optantes Simples Nacional emitido pela Receita Federal’)</span>
                                        <br /><br />                                
                                    </div>                               -->
                                </div>  
                            </div>                              
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="primary" :disabled="(!simplesNacional || arquivoSimplesNacional == null) && (!simei || arquivoSimei == null)" @click="SubmeterDados()">
                                <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                                &nbsp;&nbsp;
                                Informar Descredenciamento
                            </v-btn>                               
                          </v-card-actions>
                      </v-card>
                </v-row>
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-layout>        
    </v-flex>
</template>
<!-- 
'bmp'	 => 'image/bmp',
'jpg'	 => 'image/jpeg',
'png'	 => 'image/png',
'pdf'	 => 'application/pdf',
image/bmp, image/jpeg, image/png, application/pdf
-->
<script>
    import Vue from 'vue'
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";
import { constants } from 'fs';

    export default {
        mixins: [Helpers], 
        data() {
            return {
                fullLoading: false,
                mostrarTextoInicial: true,
                credenciamento: false,
                descredenciamento: false,
                simplesNacional: false,
                simei: false,
                aliquota : 2.00,
                arquivoSimplesNacional : null,
                arquivoSimei: null,
                ultimaEnviada: {},  
                formatField: {
                    prefix: "",
                    suffix: "",
                    thousands: "",
                    decimal: ".",
                    precision: 2                    
                },
                aliquotaRules : [
                    v => (v && v >= 2) || 'alíquota mínima é de 2,00%',
                    v => (v && v <= 5) || 'alíquota máxima é de 5,00%',
                ],                                                 
            }
        },
        methods:{
            SubmeterDados()
            {
                if(this.arquivoSimplesNacional !== null || this.arquivoSimei !== null)
                {
                    this.fullLoading = true;

                    let codigoCorretor = this.usuario.codCorretor;
                    let idUsuario = this.usuario.userRoleId;
                    let emailUsuario = this.usuario.email;
                    
                    console.log("codigoCorretor");
                    console.log(idUsuario);
                    console.log("idUsuario");
                    console.log(codigoCorretor);
                    console.log("emailUsuario");
                    console.log(emailUsuario);                                        

                    let formData = new FormData();
                    formData.append('CodigoCorretor', codigoCorretor);
                    formData.append('IdUsuario', idUsuario);
                    formData.append('EmailUsuario', emailUsuario);
                    formData.append('SimplesNacional', this.simplesNacional);
                    //formData.append('Simei', this.simei);
                    formData.append('Credenciamento', this.credenciamento);
                    if(this.credenciamento && this.simplesNacional)
                        formData.append('AliquotaTexto', this.aliquota.toString().replace(".", ","));
                        //formData.append('AliquotaSimplesNacional', JSON.stringify(this.aliquota).replace(".", ","));
                    
                    if(this.simplesNacional && this.arquivoSimplesNacional !== null)
                        formData.append('ArquivoSimplesNacional', this.arquivoSimplesNacional);
                    // if(this.simei && this.arquivoSimei !== null)
                    //     formData.append('ArquivoSimei', this.arquivoSimei);
                        
                    //console.log("AQUI  : " + JSON.stringify(this.aliquota).replace(".", ","));
                    console.log("Simples Nacional > formData");
                    console.log(this.aliquota.toString().replace(".", ","));
                    Vue.prototype.$httpPortal.post("SimplesNacional", formData, {
                        headers: { 'Content-Type': 'multipart/form-data'}
                    }
                    ).then(res => {
                        console.log(res.data);
                        if(res.data.length > 0)
                        {
                            this.showToast("error", "Erro", res.data);
                        }
                        else
                        {
                            this.showToast("success", "Sucesso", "Dados enviados!");
                        }
                        this.ObterUltima();
                        this.FinalizarEnvio();
                        
                    })
                    .catch(res => {
                        this.showToast("error", "Erro", "Falha no envio dos dados");
                        console.log(res);
                        this.ObterUltima();                        
                        this.FinalizarEnvio();

                    });                      
                }
            },
            FinalizarEnvio()
            {
                this.fullLoading = false;
                this.mostrarTextoInicial = true;
                this.credenciamento = false;
                this.descredenciamento = false;
                this.simplesNacional = false;
                this.simei = false;
                this.arquivoSimplesNacional = null;
                this.arquivoSimei = null;       
            }, 
            ObterUltima()
            {
                this.fullLoading = true;                
                let codigoCorretor = this.usuario.codCorretor;
                let url = "SimplesNacional/"+codigoCorretor;
                
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    this.ultimaEnviada = res.data.data;
                    this.fullLoading = false;               
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                    this.fullLoading = false;
                });                
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2);
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },                                     
        },
        watch: {
            aliquota(value){
                if (value >= 2 && value <= 5)
                {
                    this.aliquotaValida = true;
                }
                else
                {
                    this.aliquotaValida = false;
                }
                console.log("watch > aliquota");
                console.log(value);
                console.log("this.aliquotaValida");
                console.log(this.aliquotaValida);

            }              
        },         
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.ObterUltima();            
        },                        
    }
</script>
